export default __webpack_public_path__ + "cfd2d9ed8d10597e2bdff4db5cd81c5a.png";